import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/services/mobile-apps")({ beforeLoad: redirectTo("/services/mobile-application") });
